export const baseUrl = 'https://celebri-backend.onrender.com'